/* tslint:disable */
/*
 * Autogenerated by @creditkarma/thrift-typescript v2.0.14
 * DO NOT EDIT UNLESS YOU ARE SURE THAT YOU KNOW WHAT YOU ARE DOING
*/
import * as thrift from "thrift";
import * as PContact from "./../../common/models";
export enum TAppDirectoryFieldDataType {
    FREE_FORM_TEXT = 0,
    PHONE = 1,
    EMAIL = 2,
    ADDRESS = 3,
    THIRD_PARTY_ID = 4,
    PROFESSIONAL_INFO = 5,
    BIRTHDAY = 6,
    NAME = 7
}
export enum TAppDirectoryType {
    CUSTOM = 0,
    FAMILY = 1,
    FRIENDS = 2,
    CLASS = 3,
    CLUB = 4,
    PROFESSIONAL = 5
}
export enum TDirectoryInviteStatus {
    PENDING = 0,
    ACCEPTED = 1,
    REJECTED = 2
}
export interface ITAppDirectoryArgs {
    id: string;
    fieldDefinitions: Map<number, TAppDirectoryFieldDefinition>;
    fieldOrdering: Array<number>;
    name: string;
    type: TAppDirectoryType;
    url?: string;
    hasPasscode: boolean;
    totalMembers?: number;
    passcode?: string;
}
export class TAppDirectory {
    public id: string;
    public fieldDefinitions: Map<number, TAppDirectoryFieldDefinition>;
    public fieldOrdering: Array<number>;
    public name: string;
    public type: TAppDirectoryType;
    public url?: string;
    public hasPasscode: boolean;
    public totalMembers?: number;
    public passcode?: string;
    constructor(args: ITAppDirectoryArgs) {
        if (args != null && args.id != null) {
            this.id = args.id;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[id] is unset!");
        }
        if (args != null && args.fieldDefinitions != null) {
            this.fieldDefinitions = args.fieldDefinitions;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[fieldDefinitions] is unset!");
        }
        if (args != null && args.fieldOrdering != null) {
            this.fieldOrdering = args.fieldOrdering;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[fieldOrdering] is unset!");
        }
        if (args != null && args.name != null) {
            this.name = args.name;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[name] is unset!");
        }
        if (args != null && args.type != null) {
            this.type = args.type;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[type] is unset!");
        }
        if (args != null && args.url != null) {
            this.url = args.url;
        }
        if (args != null && args.hasPasscode != null) {
            this.hasPasscode = args.hasPasscode;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[hasPasscode] is unset!");
        }
        if (args != null && args.totalMembers != null) {
            this.totalMembers = args.totalMembers;
        }
        if (args != null && args.passcode != null) {
            this.passcode = args.passcode;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppDirectory");
        if (this.id != null) {
            output.writeFieldBegin("id", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.id);
            output.writeFieldEnd();
        }
        if (this.fieldDefinitions != null) {
            output.writeFieldBegin("fieldDefinitions", thrift.Thrift.Type.MAP, 2);
            output.writeMapBegin(thrift.Thrift.Type.I32, thrift.Thrift.Type.STRUCT, this.fieldDefinitions.size);
            this.fieldDefinitions.forEach((value_1: TAppDirectoryFieldDefinition, key_1: number): void => {
                output.writeI32(key_1);
                value_1.write(output);
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        if (this.fieldOrdering != null) {
            output.writeFieldBegin("fieldOrdering", thrift.Thrift.Type.LIST, 3);
            output.writeListBegin(thrift.Thrift.Type.I32, this.fieldOrdering.length);
            this.fieldOrdering.forEach((value_2: number): void => {
                output.writeI32(value_2);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.name != null) {
            output.writeFieldBegin("name", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.name);
            output.writeFieldEnd();
        }
        if (this.type != null) {
            output.writeFieldBegin("type", thrift.Thrift.Type.I32, 5);
            output.writeI32(this.type);
            output.writeFieldEnd();
        }
        if (this.url != null) {
            output.writeFieldBegin("url", thrift.Thrift.Type.STRING, 6);
            output.writeString(this.url);
            output.writeFieldEnd();
        }
        if (this.hasPasscode != null) {
            output.writeFieldBegin("hasPasscode", thrift.Thrift.Type.BOOL, 7);
            output.writeBool(this.hasPasscode);
            output.writeFieldEnd();
        }
        if (this.totalMembers != null) {
            output.writeFieldBegin("totalMembers", thrift.Thrift.Type.I32, 8);
            output.writeI32(this.totalMembers);
            output.writeFieldEnd();
        }
        if (this.passcode != null) {
            output.writeFieldBegin("passcode", thrift.Thrift.Type.STRING, 9);
            output.writeString(this.passcode);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppDirectory {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_3: string = input.readString();
                        _args.id = value_3;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_4: Map<number, TAppDirectoryFieldDefinition> = new Map<number, TAppDirectoryFieldDefinition>();
                        const metadata_1: thrift.TMap = input.readMapBegin();
                        const size_1: number = metadata_1.size;
                        for (let i_1: number = 0; i_1 < size_1; i_1++) {
                            const key_2: number = input.readI32();
                            const value_5: TAppDirectoryFieldDefinition = TAppDirectoryFieldDefinition.read(input);
                            value_4.set(key_2, value_5);
                        }
                        input.readMapEnd();
                        _args.fieldDefinitions = value_4;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_6: Array<number> = new Array<number>();
                        const metadata_2: thrift.TList = input.readListBegin();
                        const size_2: number = metadata_2.size;
                        for (let i_2: number = 0; i_2 < size_2; i_2++) {
                            const value_7: number = input.readI32();
                            value_6.push(value_7);
                        }
                        input.readListEnd();
                        _args.fieldOrdering = value_6;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_8: string = input.readString();
                        _args.name = value_8;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_9: TAppDirectoryType = input.readI32();
                        _args.type = value_9;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_10: string = input.readString();
                        _args.url = value_10;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_11: boolean = input.readBool();
                        _args.hasPasscode = value_11;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_12: number = input.readI32();
                        _args.totalMembers = value_12;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 9:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_13: string = input.readString();
                        _args.passcode = value_13;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.id !== undefined && _args.fieldDefinitions !== undefined && _args.fieldOrdering !== undefined && _args.name !== undefined && _args.type !== undefined && _args.hasPasscode !== undefined) {
            return new TAppDirectory(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppDirectory from input");
        }
    }
}
export interface ITAppDirectoryFieldDefinitionArgs {
    fieldOrderId: number;
    fieldName: string;
    fieldDataType: TAppDirectoryFieldDataType;
    isRequired: boolean;
    isMultiple: boolean;
}
export class TAppDirectoryFieldDefinition {
    public fieldOrderId: number;
    public fieldName: string;
    public fieldDataType: TAppDirectoryFieldDataType;
    public isRequired: boolean;
    public isMultiple: boolean;
    constructor(args: ITAppDirectoryFieldDefinitionArgs) {
        if (args != null && args.fieldOrderId != null) {
            this.fieldOrderId = args.fieldOrderId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[fieldOrderId] is unset!");
        }
        if (args != null && args.fieldName != null) {
            this.fieldName = args.fieldName;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[fieldName] is unset!");
        }
        if (args != null && args.fieldDataType != null) {
            this.fieldDataType = args.fieldDataType;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[fieldDataType] is unset!");
        }
        if (args != null && args.isRequired != null) {
            this.isRequired = args.isRequired;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[isRequired] is unset!");
        }
        if (args != null && args.isMultiple != null) {
            this.isMultiple = args.isMultiple;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[isMultiple] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppDirectoryFieldDefinition");
        if (this.fieldOrderId != null) {
            output.writeFieldBegin("fieldOrderId", thrift.Thrift.Type.I32, 1);
            output.writeI32(this.fieldOrderId);
            output.writeFieldEnd();
        }
        if (this.fieldName != null) {
            output.writeFieldBegin("fieldName", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.fieldName);
            output.writeFieldEnd();
        }
        if (this.fieldDataType != null) {
            output.writeFieldBegin("fieldDataType", thrift.Thrift.Type.I32, 3);
            output.writeI32(this.fieldDataType);
            output.writeFieldEnd();
        }
        if (this.isRequired != null) {
            output.writeFieldBegin("isRequired", thrift.Thrift.Type.BOOL, 4);
            output.writeBool(this.isRequired);
            output.writeFieldEnd();
        }
        if (this.isMultiple != null) {
            output.writeFieldBegin("isMultiple", thrift.Thrift.Type.BOOL, 5);
            output.writeBool(this.isMultiple);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppDirectoryFieldDefinition {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_14: number = input.readI32();
                        _args.fieldOrderId = value_14;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_15: string = input.readString();
                        _args.fieldName = value_15;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_16: TAppDirectoryFieldDataType = input.readI32();
                        _args.fieldDataType = value_16;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_17: boolean = input.readBool();
                        _args.isRequired = value_17;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_18: boolean = input.readBool();
                        _args.isMultiple = value_18;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.fieldOrderId !== undefined && _args.fieldName !== undefined && _args.fieldDataType !== undefined && _args.isRequired !== undefined && _args.isMultiple !== undefined) {
            return new TAppDirectoryFieldDefinition(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppDirectoryFieldDefinition from input");
        }
    }
}
export interface ITAppDirectoryMemberInfoArgs {
    userId: string;
    memberInfo: Map<number, Array<TAppDirectoryFieldData>>;
}
export class TAppDirectoryMemberInfo {
    public userId: string;
    public memberInfo: Map<number, Array<TAppDirectoryFieldData>>;
    constructor(args: ITAppDirectoryMemberInfoArgs) {
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
        if (args != null && args.memberInfo != null) {
            this.memberInfo = args.memberInfo;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[memberInfo] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppDirectoryMemberInfo");
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        if (this.memberInfo != null) {
            output.writeFieldBegin("memberInfo", thrift.Thrift.Type.MAP, 2);
            output.writeMapBegin(thrift.Thrift.Type.I32, thrift.Thrift.Type.LIST, this.memberInfo.size);
            this.memberInfo.forEach((value_19: Array<TAppDirectoryFieldData>, key_3: number): void => {
                output.writeI32(key_3);
                output.writeListBegin(thrift.Thrift.Type.STRUCT, value_19.length);
                value_19.forEach((value_20: TAppDirectoryFieldData): void => {
                    value_20.write(output);
                });
                output.writeListEnd();
            });
            output.writeMapEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppDirectoryMemberInfo {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_21: string = input.readString();
                        _args.userId = value_21;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.MAP) {
                        const value_22: Map<number, Array<TAppDirectoryFieldData>> = new Map<number, Array<TAppDirectoryFieldData>>();
                        const metadata_3: thrift.TMap = input.readMapBegin();
                        const size_3: number = metadata_3.size;
                        for (let i_3: number = 0; i_3 < size_3; i_3++) {
                            const key_4: number = input.readI32();
                            const value_23: Array<TAppDirectoryFieldData> = new Array<TAppDirectoryFieldData>();
                            const metadata_4: thrift.TList = input.readListBegin();
                            const size_4: number = metadata_4.size;
                            for (let i_4: number = 0; i_4 < size_4; i_4++) {
                                const value_24: TAppDirectoryFieldData = TAppDirectoryFieldData.read(input);
                                value_23.push(value_24);
                            }
                            input.readListEnd();
                            value_22.set(key_4, value_23);
                        }
                        input.readMapEnd();
                        _args.memberInfo = value_22;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.userId !== undefined && _args.memberInfo !== undefined) {
            return new TAppDirectoryMemberInfo(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppDirectoryMemberInfo from input");
        }
    }
}
export interface ITAppInvitedDirectoryMemberArgs {
    name?: PContact.TAppName;
    email: PContact.TAppEmail;
    inviterName?: PContact.TAppName;
    inviteStatus?: TDirectoryInviteStatus;
    hasAdditionalActions?: boolean;
}
export class TAppInvitedDirectoryMember {
    public name?: PContact.TAppName;
    public email: PContact.TAppEmail;
    public inviterName?: PContact.TAppName;
    public inviteStatus?: TDirectoryInviteStatus;
    public hasAdditionalActions?: boolean;
    constructor(args: ITAppInvitedDirectoryMemberArgs) {
        if (args != null && args.name != null) {
            this.name = args.name;
        }
        if (args != null && args.email != null) {
            this.email = args.email;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[email] is unset!");
        }
        if (args != null && args.inviterName != null) {
            this.inviterName = args.inviterName;
        }
        if (args != null && args.inviteStatus != null) {
            this.inviteStatus = args.inviteStatus;
        }
        if (args != null && args.hasAdditionalActions != null) {
            this.hasAdditionalActions = args.hasAdditionalActions;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppInvitedDirectoryMember");
        if (this.name != null) {
            output.writeFieldBegin("name", thrift.Thrift.Type.STRUCT, 1);
            this.name.write(output);
            output.writeFieldEnd();
        }
        if (this.email != null) {
            output.writeFieldBegin("email", thrift.Thrift.Type.STRUCT, 2);
            this.email.write(output);
            output.writeFieldEnd();
        }
        if (this.inviterName != null) {
            output.writeFieldBegin("inviterName", thrift.Thrift.Type.STRUCT, 3);
            this.inviterName.write(output);
            output.writeFieldEnd();
        }
        if (this.inviteStatus != null) {
            output.writeFieldBegin("inviteStatus", thrift.Thrift.Type.I32, 4);
            output.writeI32(this.inviteStatus);
            output.writeFieldEnd();
        }
        if (this.hasAdditionalActions != null) {
            output.writeFieldBegin("hasAdditionalActions", thrift.Thrift.Type.BOOL, 5);
            output.writeBool(this.hasAdditionalActions);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppInvitedDirectoryMember {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_25: PContact.TAppName = PContact.TAppName.read(input);
                        _args.name = value_25;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_26: PContact.TAppEmail = PContact.TAppEmail.read(input);
                        _args.email = value_26;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_27: PContact.TAppName = PContact.TAppName.read(input);
                        _args.inviterName = value_27;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_28: TDirectoryInviteStatus = input.readI32();
                        _args.inviteStatus = value_28;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_29: boolean = input.readBool();
                        _args.hasAdditionalActions = value_29;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.email !== undefined) {
            return new TAppInvitedDirectoryMember(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAppInvitedDirectoryMember from input");
        }
    }
}
export interface ITCreateDirectoryRequestArgs {
    directory: TAppDirectory;
    passcode?: string;
}
export class TCreateDirectoryRequest {
    public directory: TAppDirectory;
    public passcode?: string;
    constructor(args: ITCreateDirectoryRequestArgs) {
        if (args != null && args.directory != null) {
            this.directory = args.directory;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directory] is unset!");
        }
        if (args != null && args.passcode != null) {
            this.passcode = args.passcode;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TCreateDirectoryRequest");
        if (this.directory != null) {
            output.writeFieldBegin("directory", thrift.Thrift.Type.STRUCT, 1);
            this.directory.write(output);
            output.writeFieldEnd();
        }
        if (this.passcode != null) {
            output.writeFieldBegin("passcode", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.passcode);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TCreateDirectoryRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_30: TAppDirectory = TAppDirectory.read(input);
                        _args.directory = value_30;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_31: string = input.readString();
                        _args.passcode = value_31;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directory !== undefined) {
            return new TCreateDirectoryRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TCreateDirectoryRequest from input");
        }
    }
}
export interface ITCreateDirectoryResponseArgs {
    directoryId: string;
    url: string;
    hasPasscode: boolean;
}
export class TCreateDirectoryResponse {
    public directoryId: string;
    public url: string;
    public hasPasscode: boolean;
    constructor(args: ITCreateDirectoryResponseArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
        if (args != null && args.url != null) {
            this.url = args.url;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[url] is unset!");
        }
        if (args != null && args.hasPasscode != null) {
            this.hasPasscode = args.hasPasscode;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[hasPasscode] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TCreateDirectoryResponse");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        if (this.url != null) {
            output.writeFieldBegin("url", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.url);
            output.writeFieldEnd();
        }
        if (this.hasPasscode != null) {
            output.writeFieldBegin("hasPasscode", thrift.Thrift.Type.BOOL, 3);
            output.writeBool(this.hasPasscode);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TCreateDirectoryResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_32: string = input.readString();
                        _args.directoryId = value_32;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_33: string = input.readString();
                        _args.url = value_33;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_34: boolean = input.readBool();
                        _args.hasPasscode = value_34;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined && _args.url !== undefined && _args.hasPasscode !== undefined) {
            return new TCreateDirectoryResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TCreateDirectoryResponse from input");
        }
    }
}
export interface ITUpdateDirectoryInfoRequestArgs {
    oldDirectory: TAppDirectory;
    newDirectory: TAppDirectory;
}
export class TUpdateDirectoryInfoRequest {
    public oldDirectory: TAppDirectory;
    public newDirectory: TAppDirectory;
    constructor(args: ITUpdateDirectoryInfoRequestArgs) {
        if (args != null && args.oldDirectory != null) {
            this.oldDirectory = args.oldDirectory;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[oldDirectory] is unset!");
        }
        if (args != null && args.newDirectory != null) {
            this.newDirectory = args.newDirectory;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[newDirectory] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateDirectoryInfoRequest");
        if (this.oldDirectory != null) {
            output.writeFieldBegin("oldDirectory", thrift.Thrift.Type.STRUCT, 1);
            this.oldDirectory.write(output);
            output.writeFieldEnd();
        }
        if (this.newDirectory != null) {
            output.writeFieldBegin("newDirectory", thrift.Thrift.Type.STRUCT, 2);
            this.newDirectory.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateDirectoryInfoRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_35: TAppDirectory = TAppDirectory.read(input);
                        _args.oldDirectory = value_35;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_36: TAppDirectory = TAppDirectory.read(input);
                        _args.newDirectory = value_36;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.oldDirectory !== undefined && _args.newDirectory !== undefined) {
            return new TUpdateDirectoryInfoRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUpdateDirectoryInfoRequest from input");
        }
    }
}
export interface ITUpdateDirectoryInfoResponseArgs {
}
export class TUpdateDirectoryInfoResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateDirectoryInfoResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateDirectoryInfoResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUpdateDirectoryInfoResponse();
    }
}
export interface ITDeleteDirectoryRequestArgs {
    directoryId: string;
}
export class TDeleteDirectoryRequest {
    public directoryId: string;
    constructor(args: ITDeleteDirectoryRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeleteDirectoryRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeleteDirectoryRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_37: string = input.readString();
                        _args.directoryId = value_37;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined) {
            return new TDeleteDirectoryRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDeleteDirectoryRequest from input");
        }
    }
}
export interface ITDeleteDirectoryResponseArgs {
}
export class TDeleteDirectoryResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeleteDirectoryResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeleteDirectoryResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TDeleteDirectoryResponse();
    }
}
export interface ITFetchDirectoryRequestArgs {
    directoryId: string;
}
export class TFetchDirectoryRequest {
    public directoryId: string;
    constructor(args: ITFetchDirectoryRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchDirectoryRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchDirectoryRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_38: string = input.readString();
                        _args.directoryId = value_38;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined) {
            return new TFetchDirectoryRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchDirectoryRequest from input");
        }
    }
}
export interface ITFetchDirectoryResponseArgs {
    directory: TAppDirectory;
}
export class TFetchDirectoryResponse {
    public directory: TAppDirectory;
    constructor(args: ITFetchDirectoryResponseArgs) {
        if (args != null && args.directory != null) {
            this.directory = args.directory;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directory] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchDirectoryResponse");
        if (this.directory != null) {
            output.writeFieldBegin("directory", thrift.Thrift.Type.STRUCT, 1);
            this.directory.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchDirectoryResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_39: TAppDirectory = TAppDirectory.read(input);
                        _args.directory = value_39;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directory !== undefined) {
            return new TFetchDirectoryResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchDirectoryResponse from input");
        }
    }
}
export interface ITFetchDirectoryWithPasscodeRequestArgs {
    directoryId: string;
}
export class TFetchDirectoryWithPasscodeRequest {
    public directoryId: string;
    constructor(args: ITFetchDirectoryWithPasscodeRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchDirectoryWithPasscodeRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchDirectoryWithPasscodeRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_40: string = input.readString();
                        _args.directoryId = value_40;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined) {
            return new TFetchDirectoryWithPasscodeRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchDirectoryWithPasscodeRequest from input");
        }
    }
}
export interface ITFetchDirectoryWithPasscodeResponseArgs {
    directory: TAppDirectory;
}
export class TFetchDirectoryWithPasscodeResponse {
    public directory: TAppDirectory;
    constructor(args: ITFetchDirectoryWithPasscodeResponseArgs) {
        if (args != null && args.directory != null) {
            this.directory = args.directory;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directory] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchDirectoryWithPasscodeResponse");
        if (this.directory != null) {
            output.writeFieldBegin("directory", thrift.Thrift.Type.STRUCT, 1);
            this.directory.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchDirectoryWithPasscodeResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_41: TAppDirectory = TAppDirectory.read(input);
                        _args.directory = value_41;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directory !== undefined) {
            return new TFetchDirectoryWithPasscodeResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchDirectoryWithPasscodeResponse from input");
        }
    }
}
export interface ITFetchDirectoriesRequestArgs {
}
export class TFetchDirectoriesRequest {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchDirectoriesRequest");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchDirectoriesRequest {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchDirectoriesRequest();
    }
}
export interface ITFetchDirectoriesResponseArgs {
    directories: Array<TAppDirectory>;
}
export class TFetchDirectoriesResponse {
    public directories: Array<TAppDirectory>;
    constructor(args: ITFetchDirectoriesResponseArgs) {
        if (args != null && args.directories != null) {
            this.directories = args.directories;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directories] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchDirectoriesResponse");
        if (this.directories != null) {
            output.writeFieldBegin("directories", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.directories.length);
            this.directories.forEach((value_42: TAppDirectory): void => {
                value_42.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchDirectoriesResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_43: Array<TAppDirectory> = new Array<TAppDirectory>();
                        const metadata_5: thrift.TList = input.readListBegin();
                        const size_5: number = metadata_5.size;
                        for (let i_5: number = 0; i_5 < size_5; i_5++) {
                            const value_44: TAppDirectory = TAppDirectory.read(input);
                            value_43.push(value_44);
                        }
                        input.readListEnd();
                        _args.directories = value_43;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directories !== undefined) {
            return new TFetchDirectoriesResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchDirectoriesResponse from input");
        }
    }
}
export interface ITAddDirectoryMemberInfoRequestArgs {
    directoryId: string;
    memberInfo: TAppDirectoryMemberInfo;
    passcode?: string;
    inviteId?: string;
}
export class TAddDirectoryMemberInfoRequest {
    public directoryId: string;
    public memberInfo: TAppDirectoryMemberInfo;
    public passcode?: string;
    public inviteId?: string;
    constructor(args: ITAddDirectoryMemberInfoRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
        if (args != null && args.memberInfo != null) {
            this.memberInfo = args.memberInfo;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[memberInfo] is unset!");
        }
        if (args != null && args.passcode != null) {
            this.passcode = args.passcode;
        }
        if (args != null && args.inviteId != null) {
            this.inviteId = args.inviteId;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddDirectoryMemberInfoRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        if (this.memberInfo != null) {
            output.writeFieldBegin("memberInfo", thrift.Thrift.Type.STRUCT, 2);
            this.memberInfo.write(output);
            output.writeFieldEnd();
        }
        if (this.passcode != null) {
            output.writeFieldBegin("passcode", thrift.Thrift.Type.STRING, 3);
            output.writeString(this.passcode);
            output.writeFieldEnd();
        }
        if (this.inviteId != null) {
            output.writeFieldBegin("inviteId", thrift.Thrift.Type.STRING, 4);
            output.writeString(this.inviteId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddDirectoryMemberInfoRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_45: string = input.readString();
                        _args.directoryId = value_45;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_46: TAppDirectoryMemberInfo = TAppDirectoryMemberInfo.read(input);
                        _args.memberInfo = value_46;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_47: string = input.readString();
                        _args.passcode = value_47;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_48: string = input.readString();
                        _args.inviteId = value_48;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined && _args.memberInfo !== undefined) {
            return new TAddDirectoryMemberInfoRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TAddDirectoryMemberInfoRequest from input");
        }
    }
}
export interface ITAddDirectoryMemberInfoResponseArgs {
}
export class TAddDirectoryMemberInfoResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAddDirectoryMemberInfoResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAddDirectoryMemberInfoResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TAddDirectoryMemberInfoResponse();
    }
}
export interface ITUpdateDirectoryMemberInfoRequestArgs {
    directoryId: string;
    oldMemberInfo: TAppDirectoryMemberInfo;
    newMemberInfo: TAppDirectoryMemberInfo;
}
export class TUpdateDirectoryMemberInfoRequest {
    public directoryId: string;
    public oldMemberInfo: TAppDirectoryMemberInfo;
    public newMemberInfo: TAppDirectoryMemberInfo;
    constructor(args: ITUpdateDirectoryMemberInfoRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
        if (args != null && args.oldMemberInfo != null) {
            this.oldMemberInfo = args.oldMemberInfo;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[oldMemberInfo] is unset!");
        }
        if (args != null && args.newMemberInfo != null) {
            this.newMemberInfo = args.newMemberInfo;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[newMemberInfo] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateDirectoryMemberInfoRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        if (this.oldMemberInfo != null) {
            output.writeFieldBegin("oldMemberInfo", thrift.Thrift.Type.STRUCT, 2);
            this.oldMemberInfo.write(output);
            output.writeFieldEnd();
        }
        if (this.newMemberInfo != null) {
            output.writeFieldBegin("newMemberInfo", thrift.Thrift.Type.STRUCT, 3);
            this.newMemberInfo.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateDirectoryMemberInfoRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_49: string = input.readString();
                        _args.directoryId = value_49;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_50: TAppDirectoryMemberInfo = TAppDirectoryMemberInfo.read(input);
                        _args.oldMemberInfo = value_50;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_51: TAppDirectoryMemberInfo = TAppDirectoryMemberInfo.read(input);
                        _args.newMemberInfo = value_51;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined && _args.oldMemberInfo !== undefined && _args.newMemberInfo !== undefined) {
            return new TUpdateDirectoryMemberInfoRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUpdateDirectoryMemberInfoRequest from input");
        }
    }
}
export interface ITUpdateDirectoryMemberInfoResponseArgs {
}
export class TUpdateDirectoryMemberInfoResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateDirectoryMemberInfoResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateDirectoryMemberInfoResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUpdateDirectoryMemberInfoResponse();
    }
}
export interface ITDeleteDirectoryMemberInfoRequestArgs {
    directoryId: string;
    userId: string;
}
export class TDeleteDirectoryMemberInfoRequest {
    public directoryId: string;
    public userId: string;
    constructor(args: ITDeleteDirectoryMemberInfoRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeleteDirectoryMemberInfoRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeleteDirectoryMemberInfoRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_52: string = input.readString();
                        _args.directoryId = value_52;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_53: string = input.readString();
                        _args.userId = value_53;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined && _args.userId !== undefined) {
            return new TDeleteDirectoryMemberInfoRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDeleteDirectoryMemberInfoRequest from input");
        }
    }
}
export interface ITDeleteDirectoryMemberInfoResponseArgs {
}
export class TDeleteDirectoryMemberInfoResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeleteDirectoryMemberInfoResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeleteDirectoryMemberInfoResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TDeleteDirectoryMemberInfoResponse();
    }
}
export interface ITFetchDirectoryMemberRequestArgs {
    directoryId: string;
}
export class TFetchDirectoryMemberRequest {
    public directoryId: string;
    constructor(args: ITFetchDirectoryMemberRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchDirectoryMemberRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchDirectoryMemberRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_54: string = input.readString();
                        _args.directoryId = value_54;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined) {
            return new TFetchDirectoryMemberRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchDirectoryMemberRequest from input");
        }
    }
}
export interface ITFetchDirectoryMemberResponseArgs {
    memberInfo?: TAppDirectoryMemberInfo;
}
export class TFetchDirectoryMemberResponse {
    public memberInfo?: TAppDirectoryMemberInfo;
    constructor(args?: ITFetchDirectoryMemberResponseArgs) {
        if (args != null && args.memberInfo != null) {
            this.memberInfo = args.memberInfo;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchDirectoryMemberResponse");
        if (this.memberInfo != null) {
            output.writeFieldBegin("memberInfo", thrift.Thrift.Type.STRUCT, 1);
            this.memberInfo.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchDirectoryMemberResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_55: TAppDirectoryMemberInfo = TAppDirectoryMemberInfo.read(input);
                        _args.memberInfo = value_55;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchDirectoryMemberResponse(_args);
    }
}
export interface ITFetchLatestMemberInfoRequestArgs {
}
export class TFetchLatestMemberInfoRequest {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchLatestMemberInfoRequest");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchLatestMemberInfoRequest {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchLatestMemberInfoRequest();
    }
}
export interface ITFetchLatestMemberInfoResponseArgs {
    memberInfo?: TAppDirectoryMemberInfo;
}
export class TFetchLatestMemberInfoResponse {
    public memberInfo?: TAppDirectoryMemberInfo;
    constructor(args?: ITFetchLatestMemberInfoResponseArgs) {
        if (args != null && args.memberInfo != null) {
            this.memberInfo = args.memberInfo;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchLatestMemberInfoResponse");
        if (this.memberInfo != null) {
            output.writeFieldBegin("memberInfo", thrift.Thrift.Type.STRUCT, 1);
            this.memberInfo.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchLatestMemberInfoResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_56: TAppDirectoryMemberInfo = TAppDirectoryMemberInfo.read(input);
                        _args.memberInfo = value_56;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TFetchLatestMemberInfoResponse(_args);
    }
}
export interface ITFetchDirectoryMembersRequestArgs {
    directoryId: string;
}
export class TFetchDirectoryMembersRequest {
    public directoryId: string;
    constructor(args: ITFetchDirectoryMembersRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchDirectoryMembersRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchDirectoryMembersRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_57: string = input.readString();
                        _args.directoryId = value_57;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined) {
            return new TFetchDirectoryMembersRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchDirectoryMembersRequest from input");
        }
    }
}
export interface ITFetchDirectoryMembersResponseArgs {
    memberInfo: Array<TAppDirectoryMemberInfo>;
}
export class TFetchDirectoryMembersResponse {
    public memberInfo: Array<TAppDirectoryMemberInfo>;
    constructor(args: ITFetchDirectoryMembersResponseArgs) {
        if (args != null && args.memberInfo != null) {
            this.memberInfo = args.memberInfo;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[memberInfo] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchDirectoryMembersResponse");
        if (this.memberInfo != null) {
            output.writeFieldBegin("memberInfo", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.memberInfo.length);
            this.memberInfo.forEach((value_58: TAppDirectoryMemberInfo): void => {
                value_58.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchDirectoryMembersResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_59: Array<TAppDirectoryMemberInfo> = new Array<TAppDirectoryMemberInfo>();
                        const metadata_6: thrift.TList = input.readListBegin();
                        const size_6: number = metadata_6.size;
                        for (let i_6: number = 0; i_6 < size_6; i_6++) {
                            const value_60: TAppDirectoryMemberInfo = TAppDirectoryMemberInfo.read(input);
                            value_59.push(value_60);
                        }
                        input.readListEnd();
                        _args.memberInfo = value_59;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.memberInfo !== undefined) {
            return new TFetchDirectoryMembersResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchDirectoryMembersResponse from input");
        }
    }
}
export interface ITCreateMemberVCFRequestArgs {
    directoryId: string;
    userId: string;
}
export class TCreateMemberVCFRequest {
    public directoryId: string;
    public userId: string;
    constructor(args: ITCreateMemberVCFRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
        if (args != null && args.userId != null) {
            this.userId = args.userId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[userId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TCreateMemberVCFRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        if (this.userId != null) {
            output.writeFieldBegin("userId", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.userId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TCreateMemberVCFRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_61: string = input.readString();
                        _args.directoryId = value_61;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_62: string = input.readString();
                        _args.userId = value_62;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined && _args.userId !== undefined) {
            return new TCreateMemberVCFRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TCreateMemberVCFRequest from input");
        }
    }
}
export interface ITCreateMemberVCFResponseArgs {
    vcfUrl: string;
}
export class TCreateMemberVCFResponse {
    public vcfUrl: string;
    constructor(args: ITCreateMemberVCFResponseArgs) {
        if (args != null && args.vcfUrl != null) {
            this.vcfUrl = args.vcfUrl;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[vcfUrl] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TCreateMemberVCFResponse");
        if (this.vcfUrl != null) {
            output.writeFieldBegin("vcfUrl", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.vcfUrl);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TCreateMemberVCFResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_63: string = input.readString();
                        _args.vcfUrl = value_63;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.vcfUrl !== undefined) {
            return new TCreateMemberVCFResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TCreateMemberVCFResponse from input");
        }
    }
}
export interface ITCreateMembersVCFRequestArgs {
    directoryId: string;
}
export class TCreateMembersVCFRequest {
    public directoryId: string;
    constructor(args: ITCreateMembersVCFRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TCreateMembersVCFRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TCreateMembersVCFRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_64: string = input.readString();
                        _args.directoryId = value_64;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined) {
            return new TCreateMembersVCFRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TCreateMembersVCFRequest from input");
        }
    }
}
export interface ITCreateMembersVCFResponseArgs {
    vcfUrl: string;
}
export class TCreateMembersVCFResponse {
    public vcfUrl: string;
    constructor(args: ITCreateMembersVCFResponseArgs) {
        if (args != null && args.vcfUrl != null) {
            this.vcfUrl = args.vcfUrl;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[vcfUrl] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TCreateMembersVCFResponse");
        if (this.vcfUrl != null) {
            output.writeFieldBegin("vcfUrl", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.vcfUrl);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TCreateMembersVCFResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_65: string = input.readString();
                        _args.vcfUrl = value_65;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.vcfUrl !== undefined) {
            return new TCreateMembersVCFResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TCreateMembersVCFResponse from input");
        }
    }
}
export interface ITCreateMembersCSVRequestArgs {
    directoryId: string;
}
export class TCreateMembersCSVRequest {
    public directoryId: string;
    constructor(args: ITCreateMembersCSVRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TCreateMembersCSVRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TCreateMembersCSVRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_66: string = input.readString();
                        _args.directoryId = value_66;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined) {
            return new TCreateMembersCSVRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TCreateMembersCSVRequest from input");
        }
    }
}
export interface ITCreateMembersCSVResponseArgs {
    csvUrl: string;
}
export class TCreateMembersCSVResponse {
    public csvUrl: string;
    constructor(args: ITCreateMembersCSVResponseArgs) {
        if (args != null && args.csvUrl != null) {
            this.csvUrl = args.csvUrl;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[csvUrl] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TCreateMembersCSVResponse");
        if (this.csvUrl != null) {
            output.writeFieldBegin("csvUrl", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.csvUrl);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TCreateMembersCSVResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_67: string = input.readString();
                        _args.csvUrl = value_67;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.csvUrl !== undefined) {
            return new TCreateMembersCSVResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TCreateMembersCSVResponse from input");
        }
    }
}
export interface ITInviteDirectoryMemberRequestArgs {
    directoryId: string;
    invitedMember: TAppInvitedDirectoryMember;
    includePasscode?: boolean;
}
export class TInviteDirectoryMemberRequest {
    public directoryId: string;
    public invitedMember: TAppInvitedDirectoryMember;
    public includePasscode?: boolean;
    constructor(args: ITInviteDirectoryMemberRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
        if (args != null && args.invitedMember != null) {
            this.invitedMember = args.invitedMember;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[invitedMember] is unset!");
        }
        if (args != null && args.includePasscode != null) {
            this.includePasscode = args.includePasscode;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TInviteDirectoryMemberRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        if (this.invitedMember != null) {
            output.writeFieldBegin("invitedMember", thrift.Thrift.Type.STRUCT, 2);
            this.invitedMember.write(output);
            output.writeFieldEnd();
        }
        if (this.includePasscode != null) {
            output.writeFieldBegin("includePasscode", thrift.Thrift.Type.BOOL, 3);
            output.writeBool(this.includePasscode);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TInviteDirectoryMemberRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_68: string = input.readString();
                        _args.directoryId = value_68;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        const value_69: TAppInvitedDirectoryMember = TAppInvitedDirectoryMember.read(input);
                        _args.invitedMember = value_69;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_70: boolean = input.readBool();
                        _args.includePasscode = value_70;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined && _args.invitedMember !== undefined) {
            return new TInviteDirectoryMemberRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TInviteDirectoryMemberRequest from input");
        }
    }
}
export interface ITInviteDirectoryMemberResponseArgs {
}
export class TInviteDirectoryMemberResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TInviteDirectoryMemberResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TInviteDirectoryMemberResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TInviteDirectoryMemberResponse();
    }
}
export interface ITInviteDirectoryMembersRequestArgs {
    directoryId: string;
    invitedMembers: Array<TAppInvitedDirectoryMember>;
    includePasscode?: boolean;
}
export class TInviteDirectoryMembersRequest {
    public directoryId: string;
    public invitedMembers: Array<TAppInvitedDirectoryMember>;
    public includePasscode?: boolean;
    constructor(args: ITInviteDirectoryMembersRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
        if (args != null && args.invitedMembers != null) {
            this.invitedMembers = args.invitedMembers;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[invitedMembers] is unset!");
        }
        if (args != null && args.includePasscode != null) {
            this.includePasscode = args.includePasscode;
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TInviteDirectoryMembersRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        if (this.invitedMembers != null) {
            output.writeFieldBegin("invitedMembers", thrift.Thrift.Type.LIST, 2);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.invitedMembers.length);
            this.invitedMembers.forEach((value_71: TAppInvitedDirectoryMember): void => {
                value_71.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.includePasscode != null) {
            output.writeFieldBegin("includePasscode", thrift.Thrift.Type.BOOL, 3);
            output.writeBool(this.includePasscode);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TInviteDirectoryMembersRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_72: string = input.readString();
                        _args.directoryId = value_72;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_73: Array<TAppInvitedDirectoryMember> = new Array<TAppInvitedDirectoryMember>();
                        const metadata_7: thrift.TList = input.readListBegin();
                        const size_7: number = metadata_7.size;
                        for (let i_7: number = 0; i_7 < size_7; i_7++) {
                            const value_74: TAppInvitedDirectoryMember = TAppInvitedDirectoryMember.read(input);
                            value_73.push(value_74);
                        }
                        input.readListEnd();
                        _args.invitedMembers = value_73;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_75: boolean = input.readBool();
                        _args.includePasscode = value_75;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined && _args.invitedMembers !== undefined) {
            return new TInviteDirectoryMembersRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TInviteDirectoryMembersRequest from input");
        }
    }
}
export interface ITInviteDirectoryMembersResponseArgs {
}
export class TInviteDirectoryMembersResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TInviteDirectoryMembersResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TInviteDirectoryMembersResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TInviteDirectoryMembersResponse();
    }
}
export interface ITFetchInvitedDirectoryMembersRequestArgs {
    directoryId: string;
}
export class TFetchInvitedDirectoryMembersRequest {
    public directoryId: string;
    constructor(args: ITFetchInvitedDirectoryMembersRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchInvitedDirectoryMembersRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchInvitedDirectoryMembersRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_76: string = input.readString();
                        _args.directoryId = value_76;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined) {
            return new TFetchInvitedDirectoryMembersRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchInvitedDirectoryMembersRequest from input");
        }
    }
}
export interface ITFetchInvitedDirectoryMembersResponseArgs {
    invitedMembers: Array<TAppInvitedDirectoryMember>;
    totalInvitedMembers: number;
}
export class TFetchInvitedDirectoryMembersResponse {
    public invitedMembers: Array<TAppInvitedDirectoryMember>;
    public totalInvitedMembers: number;
    constructor(args: ITFetchInvitedDirectoryMembersResponseArgs) {
        if (args != null && args.invitedMembers != null) {
            this.invitedMembers = args.invitedMembers;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[invitedMembers] is unset!");
        }
        if (args != null && args.totalInvitedMembers != null) {
            this.totalInvitedMembers = args.totalInvitedMembers;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[totalInvitedMembers] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchInvitedDirectoryMembersResponse");
        if (this.invitedMembers != null) {
            output.writeFieldBegin("invitedMembers", thrift.Thrift.Type.LIST, 1);
            output.writeListBegin(thrift.Thrift.Type.STRUCT, this.invitedMembers.length);
            this.invitedMembers.forEach((value_77: TAppInvitedDirectoryMember): void => {
                value_77.write(output);
            });
            output.writeListEnd();
            output.writeFieldEnd();
        }
        if (this.totalInvitedMembers != null) {
            output.writeFieldBegin("totalInvitedMembers", thrift.Thrift.Type.I32, 2);
            output.writeI32(this.totalInvitedMembers);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchInvitedDirectoryMembersResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.LIST) {
                        const value_78: Array<TAppInvitedDirectoryMember> = new Array<TAppInvitedDirectoryMember>();
                        const metadata_8: thrift.TList = input.readListBegin();
                        const size_8: number = metadata_8.size;
                        for (let i_8: number = 0; i_8 < size_8; i_8++) {
                            const value_79: TAppInvitedDirectoryMember = TAppInvitedDirectoryMember.read(input);
                            value_78.push(value_79);
                        }
                        input.readListEnd();
                        _args.invitedMembers = value_78;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.I32) {
                        const value_80: number = input.readI32();
                        _args.totalInvitedMembers = value_80;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.invitedMembers !== undefined && _args.totalInvitedMembers !== undefined) {
            return new TFetchInvitedDirectoryMembersResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchInvitedDirectoryMembersResponse from input");
        }
    }
}
export interface ITDeclineDirectoryInviteRequestArgs {
    token: string;
}
export class TDeclineDirectoryInviteRequest {
    public token: string;
    constructor(args: ITDeclineDirectoryInviteRequestArgs) {
        if (args != null && args.token != null) {
            this.token = args.token;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[token] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeclineDirectoryInviteRequest");
        if (this.token != null) {
            output.writeFieldBegin("token", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.token);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeclineDirectoryInviteRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_81: string = input.readString();
                        _args.token = value_81;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.token !== undefined) {
            return new TDeclineDirectoryInviteRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDeclineDirectoryInviteRequest from input");
        }
    }
}
export interface ITDeclineDirectoryInviteResponseArgs {
    directoryName: string;
}
export class TDeclineDirectoryInviteResponse {
    public directoryName: string;
    constructor(args: ITDeclineDirectoryInviteResponseArgs) {
        if (args != null && args.directoryName != null) {
            this.directoryName = args.directoryName;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryName] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TDeclineDirectoryInviteResponse");
        if (this.directoryName != null) {
            output.writeFieldBegin("directoryName", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryName);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TDeclineDirectoryInviteResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_82: string = input.readString();
                        _args.directoryName = value_82;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryName !== undefined) {
            return new TDeclineDirectoryInviteResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TDeclineDirectoryInviteResponse from input");
        }
    }
}
export interface ITRemoveDirectoryInviteRequestArgs {
    directoryId: string;
    email: string;
}
export class TRemoveDirectoryInviteRequest {
    public directoryId: string;
    public email: string;
    constructor(args: ITRemoveDirectoryInviteRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
        if (args != null && args.email != null) {
            this.email = args.email;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[email] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TRemoveDirectoryInviteRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        if (this.email != null) {
            output.writeFieldBegin("email", thrift.Thrift.Type.STRING, 2);
            output.writeString(this.email);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TRemoveDirectoryInviteRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_83: string = input.readString();
                        _args.directoryId = value_83;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_84: string = input.readString();
                        _args.email = value_84;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined && _args.email !== undefined) {
            return new TRemoveDirectoryInviteRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TRemoveDirectoryInviteRequest from input");
        }
    }
}
export interface ITRemoveDirectoryInviteResponseArgs {
}
export class TRemoveDirectoryInviteResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TRemoveDirectoryInviteResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TRemoveDirectoryInviteResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TRemoveDirectoryInviteResponse();
    }
}
export interface ITFetchDirectoryNotificationPreferenceRequestArgs {
    directoryId: string;
}
export class TFetchDirectoryNotificationPreferenceRequest {
    public directoryId: string;
    constructor(args: ITFetchDirectoryNotificationPreferenceRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchDirectoryNotificationPreferenceRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchDirectoryNotificationPreferenceRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_85: string = input.readString();
                        _args.directoryId = value_85;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined) {
            return new TFetchDirectoryNotificationPreferenceRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchDirectoryNotificationPreferenceRequest from input");
        }
    }
}
export interface ITFetchDirectoryNotificationPreferenceResponseArgs {
    isOptedIn: boolean;
}
export class TFetchDirectoryNotificationPreferenceResponse {
    public isOptedIn: boolean;
    constructor(args: ITFetchDirectoryNotificationPreferenceResponseArgs) {
        if (args != null && args.isOptedIn != null) {
            this.isOptedIn = args.isOptedIn;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[isOptedIn] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TFetchDirectoryNotificationPreferenceResponse");
        if (this.isOptedIn != null) {
            output.writeFieldBegin("isOptedIn", thrift.Thrift.Type.BOOL, 1);
            output.writeBool(this.isOptedIn);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TFetchDirectoryNotificationPreferenceResponse {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_86: boolean = input.readBool();
                        _args.isOptedIn = value_86;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.isOptedIn !== undefined) {
            return new TFetchDirectoryNotificationPreferenceResponse(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TFetchDirectoryNotificationPreferenceResponse from input");
        }
    }
}
export interface ITUpdateDirectoryNotificationPreferenceRequestArgs {
    directoryId: string;
    isOptedIn: boolean;
}
export class TUpdateDirectoryNotificationPreferenceRequest {
    public directoryId: string;
    public isOptedIn: boolean;
    constructor(args: ITUpdateDirectoryNotificationPreferenceRequestArgs) {
        if (args != null && args.directoryId != null) {
            this.directoryId = args.directoryId;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[directoryId] is unset!");
        }
        if (args != null && args.isOptedIn != null) {
            this.isOptedIn = args.isOptedIn;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Required field[isOptedIn] is unset!");
        }
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateDirectoryNotificationPreferenceRequest");
        if (this.directoryId != null) {
            output.writeFieldBegin("directoryId", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.directoryId);
            output.writeFieldEnd();
        }
        if (this.isOptedIn != null) {
            output.writeFieldBegin("isOptedIn", thrift.Thrift.Type.BOOL, 2);
            output.writeBool(this.isOptedIn);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateDirectoryNotificationPreferenceRequest {
        input.readStructBegin();
        let _args: any = {};
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        const value_87: string = input.readString();
                        _args.directoryId = value_87;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.BOOL) {
                        const value_88: boolean = input.readBool();
                        _args.isOptedIn = value_88;
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_args.directoryId !== undefined && _args.isOptedIn !== undefined) {
            return new TUpdateDirectoryNotificationPreferenceRequest(_args);
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read TUpdateDirectoryNotificationPreferenceRequest from input");
        }
    }
}
export interface ITUpdateDirectoryNotificationPreferenceResponseArgs {
}
export class TUpdateDirectoryNotificationPreferenceResponse {
    constructor() {
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TUpdateDirectoryNotificationPreferenceResponse");
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TUpdateDirectoryNotificationPreferenceResponse {
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        return new TUpdateDirectoryNotificationPreferenceResponse();
    }
}
export interface ITAppDirectoryFieldDataArgs {
    freeFormText?: string;
    phoneNumber?: PContact.TAppPhone;
    emailAddress?: PContact.TAppEmail;
    address?: PContact.TAppAddress;
    thirdPartyId?: PContact.TAppThirdPartyId;
    professionalInfo?: PContact.TAppProfessionalInfo;
    birthday?: PContact.TAppDate;
    name?: PContact.TAppName;
}
export class TAppDirectoryFieldData {
    public freeFormText?: string;
    public phoneNumber?: PContact.TAppPhone;
    public emailAddress?: PContact.TAppEmail;
    public address?: PContact.TAppAddress;
    public thirdPartyId?: PContact.TAppThirdPartyId;
    public professionalInfo?: PContact.TAppProfessionalInfo;
    public birthday?: PContact.TAppDate;
    public name?: PContact.TAppName;
    constructor(args?: ITAppDirectoryFieldDataArgs) {
        let _fieldsSet: number = 0;
        if (args != null) {
            if (args.freeFormText != null) {
                _fieldsSet++;
                this.freeFormText = args.freeFormText;
            }
            if (args.phoneNumber != null) {
                _fieldsSet++;
                this.phoneNumber = args.phoneNumber;
            }
            if (args.emailAddress != null) {
                _fieldsSet++;
                this.emailAddress = args.emailAddress;
            }
            if (args.address != null) {
                _fieldsSet++;
                this.address = args.address;
            }
            if (args.thirdPartyId != null) {
                _fieldsSet++;
                this.thirdPartyId = args.thirdPartyId;
            }
            if (args.professionalInfo != null) {
                _fieldsSet++;
                this.professionalInfo = args.professionalInfo;
            }
            if (args.birthday != null) {
                _fieldsSet++;
                this.birthday = args.birthday;
            }
            if (args.name != null) {
                _fieldsSet++;
                this.name = args.name;
            }
            if (_fieldsSet > 1) {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with more than one set value!");
            }
            else if (_fieldsSet < 1) {
                throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with no set value!");
            }
        }
    }
    public static fromFreeFormText(freeFormText: string): TAppDirectoryFieldData {
        return new TAppDirectoryFieldData({ freeFormText });
    }
    public static fromPhoneNumber(phoneNumber: PContact.TAppPhone): TAppDirectoryFieldData {
        return new TAppDirectoryFieldData({ phoneNumber });
    }
    public static fromEmailAddress(emailAddress: PContact.TAppEmail): TAppDirectoryFieldData {
        return new TAppDirectoryFieldData({ emailAddress });
    }
    public static fromAddress(address: PContact.TAppAddress): TAppDirectoryFieldData {
        return new TAppDirectoryFieldData({ address });
    }
    public static fromThirdPartyId(thirdPartyId: PContact.TAppThirdPartyId): TAppDirectoryFieldData {
        return new TAppDirectoryFieldData({ thirdPartyId });
    }
    public static fromProfessionalInfo(professionalInfo: PContact.TAppProfessionalInfo): TAppDirectoryFieldData {
        return new TAppDirectoryFieldData({ professionalInfo });
    }
    public static fromBirthday(birthday: PContact.TAppDate): TAppDirectoryFieldData {
        return new TAppDirectoryFieldData({ birthday });
    }
    public static fromName(name: PContact.TAppName): TAppDirectoryFieldData {
        return new TAppDirectoryFieldData({ name });
    }
    public write(output: thrift.TProtocol): void {
        output.writeStructBegin("TAppDirectoryFieldData");
        if (this.freeFormText != null) {
            output.writeFieldBegin("freeFormText", thrift.Thrift.Type.STRING, 1);
            output.writeString(this.freeFormText);
            output.writeFieldEnd();
        }
        if (this.phoneNumber != null) {
            output.writeFieldBegin("phoneNumber", thrift.Thrift.Type.STRUCT, 2);
            this.phoneNumber.write(output);
            output.writeFieldEnd();
        }
        if (this.emailAddress != null) {
            output.writeFieldBegin("emailAddress", thrift.Thrift.Type.STRUCT, 3);
            this.emailAddress.write(output);
            output.writeFieldEnd();
        }
        if (this.address != null) {
            output.writeFieldBegin("address", thrift.Thrift.Type.STRUCT, 4);
            this.address.write(output);
            output.writeFieldEnd();
        }
        if (this.thirdPartyId != null) {
            output.writeFieldBegin("thirdPartyId", thrift.Thrift.Type.STRUCT, 5);
            this.thirdPartyId.write(output);
            output.writeFieldEnd();
        }
        if (this.professionalInfo != null) {
            output.writeFieldBegin("professionalInfo", thrift.Thrift.Type.STRUCT, 6);
            this.professionalInfo.write(output);
            output.writeFieldEnd();
        }
        if (this.birthday != null) {
            output.writeFieldBegin("birthday", thrift.Thrift.Type.STRUCT, 7);
            this.birthday.write(output);
            output.writeFieldEnd();
        }
        if (this.name != null) {
            output.writeFieldBegin("name", thrift.Thrift.Type.STRUCT, 8);
            this.name.write(output);
            output.writeFieldEnd();
        }
        output.writeFieldStop();
        output.writeStructEnd();
        return;
    }
    public static read(input: thrift.TProtocol): TAppDirectoryFieldData {
        let _fieldsSet: number = 0;
        let _returnValue: TAppDirectoryFieldData | null = null;
        input.readStructBegin();
        while (true) {
            const ret: thrift.TField = input.readFieldBegin();
            const fieldType: thrift.Thrift.Type = ret.ftype;
            const fieldId: number = ret.fid;
            if (fieldType === thrift.Thrift.Type.STOP) {
                break;
            }
            switch (fieldId) {
                case 1:
                    if (fieldType === thrift.Thrift.Type.STRING) {
                        _fieldsSet++;
                        const value_89: string = input.readString();
                        _returnValue = TAppDirectoryFieldData.fromFreeFormText(value_89);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 2:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_90: PContact.TAppPhone = PContact.TAppPhone.read(input);
                        _returnValue = TAppDirectoryFieldData.fromPhoneNumber(value_90);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 3:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_91: PContact.TAppEmail = PContact.TAppEmail.read(input);
                        _returnValue = TAppDirectoryFieldData.fromEmailAddress(value_91);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 4:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_92: PContact.TAppAddress = PContact.TAppAddress.read(input);
                        _returnValue = TAppDirectoryFieldData.fromAddress(value_92);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 5:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_93: PContact.TAppThirdPartyId = PContact.TAppThirdPartyId.read(input);
                        _returnValue = TAppDirectoryFieldData.fromThirdPartyId(value_93);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 6:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_94: PContact.TAppProfessionalInfo = PContact.TAppProfessionalInfo.read(input);
                        _returnValue = TAppDirectoryFieldData.fromProfessionalInfo(value_94);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 7:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_95: PContact.TAppDate = PContact.TAppDate.read(input);
                        _returnValue = TAppDirectoryFieldData.fromBirthday(value_95);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                case 8:
                    if (fieldType === thrift.Thrift.Type.STRUCT) {
                        _fieldsSet++;
                        const value_96: PContact.TAppName = PContact.TAppName.read(input);
                        _returnValue = TAppDirectoryFieldData.fromName(value_96);
                    }
                    else {
                        input.skip(fieldType);
                    }
                    break;
                default: {
                    input.skip(fieldType);
                }
            }
            input.readFieldEnd();
        }
        input.readStructEnd();
        if (_fieldsSet > 1) {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with more than one set value!");
        }
        else if (_fieldsSet < 1) {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.INVALID_DATA, "Cannot read a TUnion with no set value!");
        }
        if (_returnValue !== null) {
            return _returnValue;
        }
        else {
            throw new thrift.Thrift.TProtocolException(thrift.Thrift.TProtocolExceptionType.UNKNOWN, "Unable to read data for TUnion");
        }
    }
}
